import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { queriesKeys } from '../queriesKeys'

export const useGetEarningWeeklyReport = (earningId: number) =>
  useQuery({
    queryFn: () => api.earnings.getEarningWeeklyReport(earningId),
    queryKey: queriesKeys.earnings.getEarningWeeklyReport(earningId),
  })
